import { Stack } from "@mui/material"

import { StandardDateRangeFilter, DtDateRange } from "../../../../../../shared/components/table/StandardDateRangeFilter"
import { StandardExportButton } from "../../../../../../shared/components/table/StandardExportButton"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { AccountingCustomer } from "../../../../../merchant/accounting/accounting/accountingApi"
import { ResourceType } from "../../../../admin/organization/resources/resourcesTypes"

import { TenantSelector } from "./TenantSelector"
import { UsageCard } from "./UsageCard"
import { UsageResourceTypeFilter } from "./UsageResourceTypeFilter"

type TenantUsageFiltersProps = Readonly<{
    dateRange: DtDateRange
    onDateRangeChange: (value: DtDateRange) => void
    resourceType: ResourceType | undefined
    onResourceTypeChange: (type: ResourceType | undefined) => void
    tenant: AccountingCustomer | null
    onTenantChange: (tenant: AccountingCustomer | null) => void
    onExport: () => void
}>

export function TenantUsageFilters({
    dateRange,
    onDateRangeChange,
    resourceType,
    onResourceTypeChange,
    tenant,
    onTenantChange,
    onExport,
}: TenantUsageFiltersProps) {
    return (
        <UsageCard>
            <Stack direction="row" alignItems="flex-end" justifyContent="space-between" gap="1rem">
                <Stack direction="row" flexWrap="wrap" alignItems="flex-end" gap="1rem">
                    <LocalizedStrict id="service-center-usage-per-tenant-filter-date-range" attrs={{ label: true }}>
                        <StandardDateRangeFilter
                            value={dateRange}
                            onChange={onDateRangeChange}
                            label="Date range"
                            variant="labeled"
                        />
                    </LocalizedStrict>
                    <UsageResourceTypeFilter value={resourceType} onChange={onResourceTypeChange} />
                    <TenantSelector value={tenant} onChange={onTenantChange} />
                </Stack>
                <StandardExportButton bordered onClick={onExport} />
            </Stack>
        </UsageCard>
    )
}
